// Adukoo anti-clone utilities (best-effort client deterrents).
// © Adukoo Tech. All rights reserved.

/**
 * Light-touch anti-clone shim.
 *
 * History: An earlier version of this file globally blocked the right-click
 * context menu and several browser shortcuts (F12, Ctrl+U, Ctrl+S, Ctrl+Shift+I).
 * That broke basic UX expectations users have on EVERY other website:
 *  - "Copy" / "Copy link address" / "Open link in new tab" from the right-click
 *    menu were unreachable.
 *  - Sellers couldn't right-click a phone or email to copy it.
 *  - Power users couldn't open a listing in a new tab to compare two ads.
 *
 * Per founder feedback ("allow all features how other similar websites work
 * to provide best customer experience") we REMOVED those blockers. We keep
 * only the harmless deterrents:
 *  - Frame-busting (still important: prevents adukoo.com being embedded in
 *    a malicious iframe / clickjacking wrapper).
 *  - Image drag prevention (kept opt-in via `data-protected="true"`).
 *  - Console branding warning (cosmetic, hurts nobody).
 */
export function installAntiClone() {
    if (typeof window === "undefined" || window.__aduku_anticlone__) return;
    window.__aduku_anticlone__ = true;

    // Frame-busting: if loaded inside an iframe on a foreign origin, break out.
    try {
        if (window.top !== window.self) {
            const ourHost = window.location.hostname;
            const topHost = (() => { try { return window.top.location.hostname; } catch { return null; } })();
            if (topHost === null || topHost !== ourHost) {
                window.top.location = window.location.href;
            }
        }
    } catch { /* cross-origin frame: force break */
        try { window.top.location = window.location.href; } catch {}
    }

    // Console warning — cosmetic branding, blocks nothing.
    const css = "color:#0A192F;background:#F5C300;padding:6px 10px;font-weight:bold;border-radius:6px;font-size:14px;";
    // eslint-disable-next-line no-console
    console.log("%cAdukoo Tech — Stop!", css);
    // eslint-disable-next-line no-console
    console.log("%cThis is a protected, copyrighted property of Adukoo Tech. Cloning, scraping or reusing this code is prohibited.", "color:#0A192F;font-size:12px;");

    // Drag prevention only on IMAGES marked data-protected="true". Other
    // images can be dragged normally so users can save/share them like on
    // any other site (e.g. drag a listing photo into a chat).
    document.addEventListener("dragstart", (e) => {
        const t = e.target;
        if (t && t.dataset?.protected === "true") e.preventDefault();
    }, { capture: true });
}
